<template>
  <BaseInputSelect
    v-if="newDesign"
    ref="inputSelect"
    v-model="selectedValue"
    :aria-label="hideLabel ? $t('timezone_dropdown.label') : undefined"
    autocomplete="off"
    :clearable="clearable"
    :label="inputSelectorLabel"
    new-design
    :options="filteredTimeZoneOptions"
    :placeholder="$t('timezone_dropdown.placeholder')"
    use-input
    :validations="validations"
    @blur="onBlur"
    @filter="onFilter"
  />

  <QSelect
    v-else
    v-model="selectedValue"
    borderless
    :clearable="clearable"
    :dense="dense"
    emit-value
    :filled="filled"
    :label="label"
    map-options
    :options="timeZones"
    square
    use-input
    @filter="filterTimezones"
  />
</template>

<script>
import { getLocaleText } from "shared/boot/i18n";
import { BaseInputSelect } from "shared/components/base";

const TIME_ZONES = Intl.supportedValuesOf("timeZone");

export default {
  name: "TimezoneDropdown",
  components: {
    BaseInputSelect,
  },
  props: {
    modelValue: {
      type: String,
      default: "",
    },
    filled: {
      type: Boolean,
    },
    dense: {
      type: Boolean,
    },
    clearable: {
      type: Boolean,
    },
    newDesign: {
      type: Boolean,
    },
    hideLabel: {
      type: Boolean,
    },
    label: {
      type: String,
      default: () => getLocaleText("timezone_dropdown.default_label"),
    },
    validations: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      timeZones: TIME_ZONES,
      filterValue: "",
    };
  },
  computed: {
    filteredTimeZoneOptions() {
      return this.timeZones.filter((timeZone) =>
        timeZone.toLowerCase().includes(this.filterValue.toLowerCase())
      );
    },
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    inputSelectorLabel() {
      if (this.hideLabel) {
        return "";
      }

      return this.$t("timezone_dropdown.label");
    },
  },
  methods: {
    filterTimezones(val, update) {
      update(() => {
        const needle = val.toLowerCase();

        this.timeZones = TIME_ZONES.filter(
          (timeZone) => timeZone.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    onFilter(value) {
      this.filterValue = value;
    },
    onBlur() {
      this.filterValue = "";
      this.$refs.inputSelect.setFilterValue(this.selectedValue ?? "");
    },
  },
};
</script>
